const API_URL = "https://app.tavad.com/hce/wp-json/wp/v2";

export async function createGananciasLog(metaFecha, metaPaciente, logText) {
  const authToken = sessionStorage.getItem("token");
  try {
    const response = await fetch(`${API_URL}/gananciaslog`, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        status: "publish",
        meta: {
          metaFecha,
          metaPaciente,
          logText,
        },
      }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al crear ganancias log:", error);
    throw error;
  }
}

export async function getGananciasLog(userId) {
  const authToken = sessionStorage.getItem("token");
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/usergananciaslog?user=${userId}`, {
      method: "GET",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al obtener gananciaslog:", error);
    throw error;
  }
}
